const empty = [];
const emptySections = {
  eligibilityQuestions: empty,
  propertyRiskFactorQuestions: empty,
  operationalDetailsQuestions: empty
};

export const eligibilityQuestions = () => empty;
export const propertyRiskFactorQuestions = () => empty;
export const operationalDetailsQuestions = () => empty;
export const endorsementUWQuestions = empty;
export const getFarmUWQuestionSections = () => emptySections;

export default {
  eligibilityQuestions,
  propertyRiskFactorQuestions,
  operationalDetailsQuestions,
  endorsementUWQuestions,
  getFarmUWQuestionSections
};
